import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../../types/BlockTypes';
export default {
  html: _defineProperty({}, BlockTypes.PDF, function (_ref) {
    var node = _ref.node,
        attributes = _ref.attributes;
    var url = node.getIn(['data', 'url']);
    return React.createElement("figure", null, React.createElement("object", Object.assign({
      type: "application/pdf"
    }, attributes, {
      data: url,
      width: "250",
      height: "200"
    }), "PDF is not displayable"));
  })
};